import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './components/theme-provider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster } from './components/ui/toaster';
import AppWrapper from './components/AppWrapper';
import StartupComparisonTool from './components/StartupComparison';
import UnifiedOnboarding from './components/UnifiedOnboarding';
import { ReactReadyWrapper } from './components/ReactReadyWrapper';
import SaaSInvestmentCalculator from './components/SaaSInvestmentCalculator';
import Layout from './components/Layout';
import { About } from './components/About';
import './styles/globals.css';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ThemeProvider defaultTheme="dark" storageKey="saas-invest-theme">
                <Layout
                  title="Startup Builder - SaaS Investment Calculator"
                  description="Build and manage multiple SaaS startups with professional investment analysis and ROI calculations"
                >
                  <AppWrapper />
                  <Toaster />
                </Layout>
              </ThemeProvider>
            }
          />
          <Route
            path="/comparison"
            element={
              <ThemeProvider defaultTheme="dark" storageKey="startup-compare-theme">
                <Layout
                  title="Startup Valuation Comparison Tool"
                  description="Compare your startup with popular companies and project valuations through funding rounds"
                >
                  <StartupComparisonTool />
                </Layout>
              </ThemeProvider>
            }
          />
          <Route
            path="/new"
            element={
              <ThemeProvider defaultTheme="dark" storageKey="saas-invest-theme">
                <Layout
                  title="Build Your Startup - SaaS Investment Calculator"
                  description="Create your complete startup structure with our guided onboarding experience. From idea to investment-ready business model in minutes."
                >
                  <ReactReadyWrapper>
                    <UnifiedOnboarding fullScreen />
                  </ReactReadyWrapper>
                  <Toaster />
                </Layout>
              </ThemeProvider>
            }
          />
          <Route
            path="/shares"
            element={
              <ThemeProvider defaultTheme="dark" storageKey="saas-invest-theme">
                <Layout title="Share Calculator">
                  <SaaSInvestmentCalculator />
                </Layout>
              </ThemeProvider>
            }
          />
          <Route
            path="/about"
            element={
              <ThemeProvider defaultTheme="dark" storageKey="saas-invest-theme">
                <Layout
                  title="About - Startup Builder"
                  description="Learn about Startup Builder and our mission to help entrepreneurs build successful SaaS businesses"
                >
                  <About />
                </Layout>
              </ThemeProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;

